export const CONNECT = 'connect';
export const JOIN = 'join';
export const LEAVE = 'leave';
export const CLOSE = 'close';
export const MESSAGE = 'message';
export const BROADCAST = 'broadcast';
export const ERROR = 'error';
export const PING = 'ping';
export const PONG = 'pong';
export const UPDATE_ROOM_INFO = 'updateRoomInfo';
